import { Injectable } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import { KeyboardEventCodes } from './types/keyboard-event-codes.type';
import { KeyboardEventSpecialKeys } from './types/keyboard-event-special-keys.type';

// service that listen for keyboard events and represents the current state of the keyboard

/**
 * @deprecated use KeyboardEventsDirective from @lite-workspace/utils
 */
@Injectable({ providedIn: 'root' })
export class DocumentEventsService {
  public pressed: {
    [keycode in KeyboardEventCodes | KeyboardEventSpecialKeys]?: boolean;
  } = {};

  public mouseDownPosition: { x: number; y: number } | null = null;
  public currentMouseEvent: Event | undefined;

  public keydown$ = fromEvent<KeyboardEvent>(document, 'keydown');
  public keyup$ = fromEvent<KeyboardEvent>(document, 'keyup');
  public keyChange$ = new Subject<KeyboardEvent>();

  public mouseDown$ = fromEvent<MouseEvent>(document, 'mousedown');
  public mouseUp$ = fromEvent<MouseEvent>(document, 'mouseup');

  public preventDefaultForAlt = true;

  constructor() {
    const handleKeyEventsObservable = (obs: Observable<KeyboardEvent>, pressed: boolean) => {
      obs.pipe(filter(e => !e.repeat)).subscribe(e => {
        this.pressed[e.code as KeyboardEventCodes] = pressed;
        this.pressed.shiftKey = e.shiftKey;
        this.pressed.ctrlKey = e.ctrlKey;
        this.pressed.altKey = e.altKey;
        this.pressed.metaKey = e.metaKey;
        if (this.preventDefaultForAlt && e.key === 'Alt') {
          e.preventDefault();
        }

        this.keyChange$.next(e);
      });
    };

    handleKeyEventsObservable(this.keydown$, true);
    handleKeyEventsObservable(this.keyup$, false);

    this.mouseDown$.subscribe(e => {
      this.mouseDownPosition = { x: e.clientX, y: e.clientY };
    });
    this.mouseUp$.subscribe(_e => {
      this.mouseDownPosition = null;
    });

    fromEvent(document, 'visibilitychange').subscribe(_e => {
      this.pressed = {};
      this.keyChange$.next(new KeyboardEvent('keyup'));
    });

    fromEvent(window, 'blur').subscribe(() => {
      this.pressed = {};
      this.keyChange$.next(new KeyboardEvent('keyup'));
    });
    fromEvent(window, 'mousemove').subscribe(e => {
      this.currentMouseEvent = e;
    });
  }
}
